import React from "react";
import { PARTNER_AGREEMENT_SECTIONS, AGREEMENT_VERSION } from "@/lib/partnerAgreement";

/**
 * Iteration 294 — renders the full 6-section Commercial Participation
 * Agreement. `compact` mode is used inside the onboarding modal.
 */
export default function PartnerAgreementText({ compact = false }) {
  return (
    <div data-testid={compact ? "partner-agreement-text-compact" : "partner-agreement-text"}>
      {PARTNER_AGREEMENT_SECTIONS.map((s) => (
        <div key={s.n} className={compact ? "mb-3" : "mb-6"}>
          <h3
            className={compact ? "font-bold text-slate-800 text-xs" : "font-display text-xl font-semibold text-brandSlate"}
            data-testid={`partner-agreement-section-${s.n}-title`}
          >
            Section {s.n}: {s.title}
          </h3>
          {s.body.map((p, i) => (
            <p key={i} className={compact ? "mt-1 leading-relaxed" : "mt-2 text-sm text-slate-600 leading-relaxed"}>{p}</p>
          ))}
        </div>
      ))}
      <p className={compact ? "text-[10px] text-slate-400" : "text-xs text-slate-400"}>
        Agreement version {AGREEMENT_VERSION} · Digitally Prepared Ltd (t/a MyTableTopApp)
      </p>
    </div>
  );
}
